import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import care01 from "../assets/images/care01.png";

import Box from '@mui/material/Box';
import Bottom from "../Bottom";
import Top from "../Top";

import HomeTop from "../../components/HomeTop";

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';

import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useEffect } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';

import supportimg from "../../assets/images/supportimg.png";
import PhoneIcon from '@mui/icons-material/Phone';
import MarkunreadIcon from '@mui/icons-material/Markunread';

import blogIcon from "../../assets/main/blogIcon.png";
import InstagramIcon from '@mui/icons-material/Instagram';




const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Support = () => {
  const navigate = useNavigate();


  return (
    <Box>
      <Container sx={{ p:'0 !important', bgcolor: '#F6F6F6', pb:'100px !important', minWidth: 320}}>

        <Box sx={{ bgcolor: '#ffedad', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, }} >
          {/* logo */}
          <Box position={'fixed'} width={'100%'} bgcolor={'#ffedad'} zIndex={999} maxWidth={'1200px'}>
            <Stack direction={'row'} >
              <Box>
                <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                  <Img alt="Dual" src="/dual.png" />
                </ButtonBase>
              </Box>
            </Stack>
          </Box>

          <Grid container spacing={2} direction='row' sx={{ mt: 6 }}>
            <Grid container xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
              <Typography sx={{ fontSize: '2.2rem', color: '#ff9600', fontWeight: 900, }}>
                고객센터
              </Typography>
            </Grid>
            <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
              <Img alt="care" src={supportimg} />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ pt: 1, pl:2, pr:2 }}>

          {/* <Box sx={{   width: '70%', m: '0 auto' }}>
        <Img alt="DualLogo" src="/dualLogin.png" />
      </Box> */}

          <Typography sx={{ m: '20px auto 30px auto', width: '100%', textAlign: 'center', fontSize: 16, fontWeight: 600, color: '#555', }}>상담원에게 궁금한점을 문의하세요.</Typography>

          <Box sx={{ p: 2, mb: 4, bgcolor: '#fff', borderRadius: 5, boxSizing: 'border-box', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Typography sx={{ fontSize: 16, mb: 2, color: '#555', textAlign: 'center', fontWeight: 700, }}>전화 문의</Typography>
            <Box><a href="16612645" style={{ width: '100%', margin: 2, padding: '5px 0', background: '#ff9600', borderRadius: '20px', color: '#fff', display: 'block', textAlign: 'center', textDecoration: 'none', fontWeight: 700 }}><PhoneIcon sx={{ verticalAlign: 'middle', fontSize: 20 }} /> 1661-2645</a></Box>
            <Typography sx={{ fontSize: 14, mt: 2, textAlign: 'center', color: '#777' }}>고객센터 운영시간</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 700, mt: '5px', textAlign: 'center', color: '#555' }}>평일 오전 9시 ~ 오후 6시</Typography>
          </Box>

          <Box sx={{ p: 2, mb: 7, bgcolor: '#fff', borderRadius: 5, boxSizing: 'border-box', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Typography sx={{ fontSize: 16, mb: 2, color: '#555', textAlign: 'center', fontWeight: 700, }}>메일 문의</Typography>
            <Box><a href="mailto:help@dual.health" style={{ width: '100%', margin: 2, padding: '5px 0', background: '#ff9600', borderRadius: '20px', color: '#fff', display: 'block', textAlign: 'center', textDecoration: 'none', fontWeight: 700 }}><MarkunreadIcon sx={{ verticalAlign: 'middle', mr: '2px', fontSize: 20 }} /> help@dual.health</a></Box>
          </Box>

          <Box sx={{ textAlign: 'center', }}>
            <Typography sx={{ fontSize: 14, mb: '5px', fontWeight: 700 }}>(주) 듀얼헬스케어</Typography>
            <Typography sx={{ fontSize: 14, mb: '5px' }}>대전광역시 유성구 대덕대로 512번길 20, A동 303호</Typography>
            <Typography sx={{ fontSize: 14, mb: '5px' }}>통신판매업신고번호 : 제2020-대전유성-1103호</Typography>
            <Typography sx={{ fontSize: 14 }}>사업자번호 : 111-86-01943</Typography>
          </Box>

          <Stack direction={'row'} sx={{ mt: 2 }}>
            <a href="https://m.blog.naver.com/dualhealth_official" target="_blank" style={{ width: '50%', textAlign: 'right', marginRight: '20px' }}><img alt="Blog" src={blogIcon} style={{ width: '30px', opacity: '0.7' }} />  </a>
            <a href="https://www.instagram.com/dualhealth_official" target="_blank" ><InstagramIcon sx={{ color: '#929292', fontSize: 32 }} /></a>
          </Stack>



        </Box>
        <Bottom />
      </Container>
    </Box>
  );
}

export default Support;